'use client';

import { useEffect, useState } from 'react';

/**
 * Hook to check if the enhanced tables feature is enabled.
 * This feature adds multi-select, column reordering, column visibility,
 * and settings persistence to tables.
 */
export function useEnhancedTablesEnabled(): boolean {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    // Check localStorage on mount and when storage changes
    const checkEnabled = () => {
      const value = localStorage.getItem('enhanced_tables_enabled');
      setEnabled(value === '1');
    };

    checkEnabled();

    // Listen for storage changes (from other tabs/windows)
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === 'enhanced_tables_enabled') {
        checkEnabled();
      }
    };

    window.addEventListener('storage', handleStorageChange);

    // Also listen for custom event (for same tab updates)
    const handleCustomEvent = () => checkEnabled();
    window.addEventListener('enhanced-tables-toggle', handleCustomEvent);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('enhanced-tables-toggle', handleCustomEvent);
    };
  }, []);

  return enabled;
}

// Helper to dispatch custom event when toggling the feature
export function dispatchEnhancedTablesToggle() {
  window.dispatchEvent(new Event('enhanced-tables-toggle'));
}
